export const importExportPagesData: any = [{
  name: 'import-manager',
  allow: ['admin', 'catalog-edit'],
  color: 'gold',
  link: 'import-manager',
  title: 'Import Manager',
  visible: true,
}, {
  name: 'export-manager',
  allow: ['admin', 'catalog-edit', 'repository'],
  color: 'darkpurple',
  link: 'export-manager',
  title: 'Export Manager',
  visible: true,
}];
